var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',_vm._g({ref:"select",attrs:{"value":_vm.value,"items":_vm.filteredItems,"menu-props":{
    'content-class': 'snt-menu',
    'origin': 'center center',
    'transition':'slide-y-transition',
    'nudge-top': '-4px',
    'maxHeight': 320,
    'offset-y': true,
  },"placeholder":_vm.placeholder,"height":"37px","width":"248px","item-text":"text","item-value":"value","hide-details":"","outlined":"","dense":""},scopedSlots:_vm._u([{key:"selection",fn:function({ item }){return [_c('div',{staticClass:"d-flex align-center"},[_c('v-icon',{staticClass:"snt-select__icon-bank",style:({
          backgroundColor: item.option.color
        }),attrs:{"color":"#ffffff","size":"22","left":""}},[_vm._v(" $bank_"+_vm._s(item.option.value)+" ")]),_c('span',{class:`text-overflow--1`},[_vm._v(_vm._s(item.text))])],1)]}},{key:"item",fn:function({ item }){return [_c('div',{staticClass:"d-flex align-center"},[_c('v-icon',{staticClass:"snt-select__icon-bank",style:({
          backgroundColor: item.option.color
        }),attrs:{"color":"#ffffff","size":"22","left":""}},[_vm._v(" $bank_"+_vm._s(item.option.value)+" ")]),_c('span',{class:`text-overflow--1`},[_vm._v(_vm._s(item.text))])],1)]}}])},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }